import axios from '@utils/axios';

export async function getUserInfo(): Promise<UserInfo> {
  const result = await axios.get('/api/user/info');
  return result?.data;
}

export async function getUserAccessRank(): Promise<number> {
  const result = await axios.get('/api/user/access_rank');
  return result?.data?.rank;
}

export async function getUserQueueStatus(params?: {
  predict_id?: string;
}): Promise<QueueStatus> {
  const result = await axios.get('/api/user/queue_status', { params });
  return result?.data;
}

export async function getUserJoinWaitlist(): Promise<Response> {
  const result = await axios.get('/api/user/join_white_list');
  return result?.data;
}

export async function getUserUpvoteImprove(params?: {
  user_name: string;
  product: string;
}): Promise<Response> {
  const result = await axios.get('/api/user/upvote_improve', { params });
  return result?.data;
}

export async function getUserTaskStatus(params?: {
  platform?: string;
}): Promise<VideoTaskStatus> {
  const result = await axios.get('/api/user/user_status', { params });
  return result?.data?.state_info;
}

export async function getUserPortalLink(): Promise<{ portal_url: string }> {
  const result = await axios.get('/api/user/portal_link');
  return result?.data;
}

export async function postUserUpdate(params: {
  name?: string;
  avatar_fid?: string;
  usage_billing?: number;
}): Promise<number> {
  const result = await axios.post('/api/user/update', { ...params });
  return result?.status;
}

export async function postReportPayment(): Promise<{
  currency: string;
  order_id: string;
  price: number;
}> {
  const result = await axios.post('/api/user/report_payment');
  return result?.data;
}
